import { render } from "./UserAccounts.vue?vue&type=template&id=423a9b1c&ts=true"
import script from "./UserAccounts.vue?vue&type=script&lang=ts"
export * from "./UserAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__